var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsDateString, IsOptional, IsUUID } from 'class-validator';
/**
 * Patient request to place a single pending hold against a plan (PRD #1343,
 * RS-001). The patient sends ONLY the plan and the chosen slot start — the
 * therapist, treatment, duration, next unbooked unit and office are all
 * re-derived and re-validated server-side. The chosen `start` is re-checked
 * against a fresh slot search; if it was taken meanwhile the endpoint returns
 * a typed `409` conflict (see {@link PatientBookingConflictCode}).
 */
export class CreatePatientBookingDto {
    treatmentPlanId;
    start;
    /**
     * Therapist preference (RS-007). Omitted → the plan's continuity therapist. A
     * specific id books that therapist; `anyTherapist` books an auto-preselected
     * therapist free at that time and stamps the "egal" marker for the practice.
     */
    therapistId;
    anyTherapist;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreatePatientBookingDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], CreatePatientBookingDto.prototype, "start", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePatientBookingDto.prototype, "therapistId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreatePatientBookingDto.prototype, "anyTherapist", void 0);
//# sourceMappingURL=create-patient-booking.dto.js.map